import React, { useState, useMemo } from "react";
import { Button, Divider, Form, Input, Radio, Spin, Tag } from "antd";
import {
  EntityStatus,
  ServiceInstanceActions,
  ServiceInstanceMaturityState,
  tailItemLayout,
} from "../../Constants/Constants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { onFormSubmit } from "../../ApiHandlers/ServiceInstanceApiHandlers";
import { DiscardWarning } from "../Common/DiscardWarning";
import { BreadCrumbs } from "../Common/BreadCrumbs";

const getInitialValues = (instanceRecord, serviceRecord) => {
  const initialValues = {
    serviceName: serviceRecord.name,
    maturity: ServiceInstanceMaturityState.stable.value,
    status: EntityStatus.ACTIVE,
  };
  if (instanceRecord) {
    initialValues.name = instanceRecord.name;
    initialValues.maturity = instanceRecord.maturity;
    initialValues.locationName = instanceRecord.location?.name;
    initialValues.locationValue = instanceRecord.location?.value;
    initialValues.version = instanceRecord.version;
    initialValues.status = instanceRecord.status;
    initialValues.serviceName = instanceRecord.serviceName;
  }
  return initialValues;
};

const getTitle = (action) => {
  switch (action) {
    case ServiceInstanceActions.add:
      return "Add";
    case ServiceInstanceActions.edit:
      return "Update";
    case ServiceInstanceActions.view:
      return "View";
    default:
      return "";
  }
};
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};
const ServiceInstanceForm = (props) => {
  console.log("ServiceInstanceForm props", props);
  const {
    action,

    onActionClick,
    instanceRecord,
    serviceRecord,
  } = props;

  const title = useMemo(() => getTitle(action), [action]);
  const [initialValues, setInitialValues] = useState(
    getInitialValues(instanceRecord, serviceRecord)
  );
  const isViewForm = action === ServiceInstanceActions.view;

  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(false);

  const onBackClick = () => {
    const isChanged =
      action === ServiceInstanceActions.view ? false : checkForInputChanges();
    DiscardWarning({ isChanged, onActionClick })();
  };

  const checkForInputChanges = () => {
    const fieldsToCheck = [
      "name",
      "maturity",
      "locationName",
      "locationValue",
      "version",
    ];
    const values = form.getFieldsValue();
    let isInputsChanged = false;
    fieldsToCheck.every((f) => {
      if (
        values.hasOwnProperty(f) &&
        values[f] !== initialValues[f] &&
        (!!values[f] || !!initialValues[f])
      ) {
        isInputsChanged = true;
        return false;
      }
      return true;
    });
    return isInputsChanged;
  };

  return (
    <div className="list-container">
      <div className="page-header-container">
        <BreadCrumbs
          headers={props.parentBread.concat(`${title} Service Instance`)}
          onParentActionClick={onBackClick}
        />
      </div>
      <Divider className="divider" />
      <div className="form-data-container">
        <fieldset disabled={isViewForm}>
          <Form
            form={form}
            name="service-instance-form"
            layout="horizontal"
            onFinish={onFormSubmit({ props, setProcessing, setInitialValues })}
            initialValues={initialValues}
            requiredMark={"optional"}
            size={"middle"}
            {...formItemLayout}
          >
            <Spin spinning={processing} tip={"Processing, please wait..."}>
              <Form.Item
                name="serviceName"
                label="Service Name"
                wrapperCol={{ span: 6 }}
                rules={[{ required: true }]}
              >
                <Input disabled={true} />
              </Form.Item>

              <Form.Item
                hasFeedback
                name="name"
                label="Instance Name"
                wrapperCol={{ span: 6 }}
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input
                  title="Name should be unique"
                  disabled={action !== ServiceInstanceActions.add}
                />
              </Form.Item>

              <Form.Item
                name="maturity"
                label="Maturity State"
                rules={[{ required: true }]}
              >
                <Radio.Group
                  options={Object.values(ServiceInstanceMaturityState)}
                  value={initialValues.maturity}
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                name="locationName"
                label="Location Name"
                wrapperCol={{ span: 4 }}
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                hasFeedback
                name="locationValue"
                label="Location Value"
                wrapperCol={{ span: 12 }}
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                hasFeedback
                name="version"
                label="Version"
                wrapperCol={{ span: 3 }}
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true }]}
              >
                <Tag
                  color={
                    initialValues.status === EntityStatus.ACTIVE
                      ? "green"
                      : "red"
                  }
                >
                  {initialValues.status}
                </Tag>
              </Form.Item>

              {title ? (
                <Form.Item {...tailItemLayout}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                  >
                    {title}
                  </Button>
                  <Button
                    htmlType="button"
                    onClick={() => form.resetFields()}
                    className="cancel-button"
                  >
                    Cancel
                  </Button>
                </Form.Item>
              ) : null}
            </Spin>
          </Form>
        </fieldset>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceInstanceApi: state.apis.serviceInstanceApi,
});

const connectedServiceInstanceForm =
  connect(mapStateToProps)(ServiceInstanceForm);

export default withRouter(connectedServiceInstanceForm);
